import axios from "axios";
const isDev = process.env.REACT_APP_PHASE === "development";

const axiosInstance = axios.create({
  baseURL: isDev
    ? "https://asianhearthospital.co.in:8443/AHIRCACC"
    : "https://asianhearthospital.co.in:9443/AHIRCAPP",
  // baseURL: "https://asianhearthospital.co.in:9443/AHIRCAPP",
});

export default axiosInstance;
